import { Type, type Static } from '@sinclair/typebox';

export const StorySchema = Type.Object({
  object: Type.Literal('Story'),
  id: Type.String({ description: 'The ID of the story for the provider.' }),
  provider_id: Type.String({ description: "The story's raw provider-native identifier." }),
  media_type: Type.Union([Type.Literal('img'), Type.Literal('video')], {
    description: 'The type of media attached to the story.',
  }),
  created_at: Type.String({
    description: 'The creation date of the story. Uses ISO 8601 UTC datetime (YYYY-MM-DDTHH:MM:SS.sssZ).',
  }),
  expires_at: Type.Optional(
    Type.String({
      description:
        'The expiration date of the story (~24h after creation, if supported by the provider). Uses ISO 8601 UTC datetime (YYYY-MM-DDTHH:MM:SS.sssZ).',
    }),
  ),
});

export type Story = Static<typeof StorySchema>;
